<template>
  <div>
    <v-dialog
      v-model="display"
      persistent
      transition="dialog-bottom-transition"
      content-class="v-dialog-form-bottom"
    >
      <v-card flat style="width:100%">
        <v-card-title
          class="py-3 mb-6 justify-space-between"
          style="border-bottom: 1px solid #D3D2D2"
        >
          <div style="width:28px"></div>
          <span class="font-weight-bold">Report</span>
          <v-btn
            icon
            small
            @click="display = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text
        >
          <v-form>
            <v-select
              v-model="reason"
              :items="reasonList"
              label="Reason"
              placeholder="Reason"
            ></v-select>
            <v-select
              v-model="wantUs"
              :items="wantUsList"
              label="What would you like us to do?"
              placeholder="What would you like us to do?"
            ></v-select>
            <v-textarea
              v-model="comment"
              label="Other comments"
              placeholder="Other comments"
            >
            </v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn
            block
            color="primary"
            class="text-capitalize fz18 font-weight-bold mt-5"
            :disabled="process"
            :loading="process"
            @click="doSend"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <messageBox
      ref="msgBox"
    ></messageBox>
  </div>
</template>

<script>
import service from '@/plugins/service'
import MessageBox from '@/components/MessageBox'

export default {
  components: {
    MessageBox,
  },
  props: {
    fromUid: { type: String, required: true, },
    toUid: { type: String, required: true, },
    rid: { type: String, required: true, },
  },
  data: () => ({
    display: false,
    comment: '',
    process: false,
    reasonList: [
      'Sent spam',
      'Inappropriate message',
      'Other',
    ],
    reason: '',
    wantUsList: [
      'Block the user',
      'Alert the user',
      'Other',
    ],
    wantUs: '',
  }),
  methods: {
    show() {
      this.comment = ''
      this.reason = ''
      this.wantUs = ''
      this.display = true
    },
    async doSend() {
      this.process = true
      try {
        // report server処理を呼び出す
        const result = await service.doReport(this.fromUid, this.toUid, this.reason, this.wantUs, this.comment)
        if (result) {
          this.$refs.msgBox.show(
            'Confirmation😊',
            'Successfully reported!',
            'OK',
          )
          this.display = false
        }
      } finally {
        this.process = false
      }
    },
  },
};
</script>

<style lang="stylus">
.v-dialog.v-dialog-form-bottom
  width 100%
  height 90%
  margin 0
  position absolute
  bottom 0
  border-radius 32px 32px 0 0
  background #fff
</style>
